import { useEffect, useState } from 'react';

import { client } from '@/utils/apiClient';

import type { AccountState } from '../containerProps/accountState';

export const usePaStateMachine = () => {
  const [isAccessible, setIsAccessible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await client.get<AccountState>('/user/account');
        const permissionAllowed =
          data?.clientApiSettings?.paSetting?.paState !== 'FORBIDDEN';
        setIsAccessible(permissionAllowed);
        setIsError(!permissionAllowed);
        setLoading(false);
      } catch (err) {
        // eslint-disable-next-line
        console.error(err);
        setIsAccessible(false);
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  return { isAccessible, loading, isError };
};
